import { Badge } from '@e2n/ui';
import { Location } from '@/domain/mitarbeiter/features/rotationsplan/components/Location';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { faCalendarRange, faUser } from '@fortawesome/pro-regular-svg-icons';
import { faDot } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function Arbeitsbereich({
  arbeitsbereichStation,
  isNext = false,
}: {
  arbeitsbereichStation: ArbeitsbereichStation;
  isNext?: boolean;
}) {
  return (
    <div className="flex flex-col">
      <div className="flex gap-1 items-center">
        <FontAwesomeIcon
          className="w-fit"
          size="2x"
          icon={faDot}
          color={arbeitsbereichStation.arbeitsbereich.getBorderColor()}
        />
        <div className="text-xs text-neutrals-900 font-semibold">
          {arbeitsbereichStation.arbeitsbereich.name}
        </div>
        {isNext && (
          <Badge type="pill" variant="secondary">
            Geplant ab {dayjs(arbeitsbereichStation.von).format('DD.MM')}
          </Badge>
        )}
      </div>
      <div className="flex gap-4 items-center text-xs text-neutrals-700">
        <div className="flex gap-1 items-center">
          <FontAwesomeIcon fixedWidth icon={faCalendarRange} />
          {dayjs(arbeitsbereichStation.von).format('DD.MM.YYYY') +
            ' – ' +
            dayjs(arbeitsbereichStation.bis).format('DD.MM.YYYY')}
        </div>
        {arbeitsbereichStation.bereichsleiter && (
          <div className="flex items-center gap-1 grow">
            <FontAwesomeIcon icon={faUser} />
            {arbeitsbereichStation.bereichsleiter.getName()}
          </div>
        )}
        <Location standort={arbeitsbereichStation.arbeitsbereich.standort} />
      </div>
    </div>
  );
}
